import { createContext, useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { es } from "../locales/es";
import { en } from "../locales/en";

const translations = { es, en };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const stored = localStorage.getItem("appLanguage");
    if (!stored) localStorage.setItem("appLanguage", "es");
    return stored || "es";
  });

  const setLanguage = useCallback((lang) => {
    localStorage.setItem("appLanguage", lang);
    setLanguageState(lang);
  }, []);

  const t = useCallback(
    (key) => {
      const keys = key.split(".");
      let value = translations[language];
      for (const k of keys) {
        value = value?.[k];
      }
      if (value !== undefined) return value;

      // Fallback a español
      let fallback = translations["es"];
      for (const k of keys) {
        fallback = fallback?.[k];
      }
      return fallback !== undefined ? fallback : key;
    },
    [language]
  );

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage debe usarse dentro de LanguageProvider");
  }
  return context;
}
